import type { Placement } from '@floating-ui/dom';

export type ControlDropdownPosition = 'left' | 'right' | 'middle';

/** Maps explicit caller position to a floating-ui placement (anchor edge alignment). */
export const resolveControlDropdownPlacement = (
  position: ControlDropdownPosition | undefined
): Placement => {
  if (position === 'right') return 'bottom-end';
  if (position === 'middle') return 'bottom';
  return 'bottom-start';
};
